import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class PrintService {
    isPrinting = false;
    private _data: any = null;

    constructor(private router: Router) { }

    get data() { return this._data }
    set data(data: any) { this._data = data }

    printDocument(documentName: string) {
        this.isPrinting = true;
        this.router.navigate(['',
            {
                outlets: {
                    'print': ['print', documentName]
                }
            }]);
    }

    onDataReady(name) {
        setTimeout(() => {
            document.title = name;
            window.print();
            this.isPrinting = false;
            this.router.navigate([{ outlets: { print: null } }]);
        }, 400);
    }
}
